import { useEffect } from "react";
import "./OptionChooser.css";

interface ButtonSelectorProps {
  options: Record<string, string>;
  selectedOption?: string;
  setSelectedOption: (option: string) => void;
  optionDescription: string;
}

const ButtonSelector: React.FC<ButtonSelectorProps> = ({
  options,
  selectedOption,
  setSelectedOption,
  optionDescription,
}) => {
  useEffect(() => {
    if (!selectedOption) {
      const firstOption = Object.keys(options)[0];
      if (firstOption) {
        setSelectedOption(firstOption);
      }
    }
  }, []);

  return (
    <div>
      <label className="store-front-label">{optionDescription}</label>
      <div className="store-front-button-group">
        {Object.entries(options).map(([key, value]) => (
          <button
            key={key}
            className={`store-front-button ${
              selectedOption === key ? "active" : ""
            }`}
            onClick={() => setSelectedOption(key)}
          >
            {value}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ButtonSelector;
